import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    CFADividerCont: (filterShowHide, isMapPage, isMobile) => css`
      width: 100%;
      margin: ${isMapPage ? '0' : '2.5rem auto 0'};
      text-align: center;
      display: ${isMobile ? 'inline-block' : 'flex'};
      align-items: center;
      justify-content: center;
      column-gap: ${isMapPage ? '0.5rem' : '1.25rem'};
      grid-column-start: 1;
      grid-column-end: 2;
      ${breakpoints.m} {
        grid-column-end: ${filterShowHide ? '2' : '3'};
      }
      ${breakpoints.l} {
        grid-column-end: ${filterShowHide ? '3' : '4'};
      }
    `,
    CFADividerLeftFill: isMapPage => css`
      height: 1px;
      background-color: ${colors.divider_gray};
      flex: ${isMapPage ? '0 0 1.5rem' : '1.5'};
    `,
    CFADividerText: css`
      color: ${colors.divider_gray};
      font-family: FS Dillon;
      font-weight: 400;
      letter-spacing: 0.02rem;
      line-height: 1.25rem;
      flex: 9;
      ${breakpoints.l} {
        font-size: 1.125rem;
      }
      ${breakpoints.xxs} {
        font-size: 1rem;
      }
    `,
    CFADividerLink: css`
      display: inline;
      color: ${colors.divider_gray};
      font-family: FS Dillon;
      font-weight: 400;
      letter-spacing: 0.02rem;
      line-height: 1.25rem;
      text-decoration: underline;
      &:visited {
        color: ${colors.divider_gray};
      }
      &:hover {
        outline: none;
        color: ${colors.black};
        font-weight: 700;
      }
      &:focus-visible:not(:hover) {
        color: ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
        text-decoration-color: ${colors.border_black};
        padding: 2px 4px;
        outline: none;
      }
      ${breakpoints.l} {
        font-size: 1.125rem;
      }
      ${breakpoints.xxs} {
        font-size: 1rem;
      }
    `,
    CFADividerRightFill: isMapPage => css`
      height: 1px;
      background-color: ${colors.divider_gray};
      flex: ${isMapPage ? '0 0 1.5rem' : '1.5'};
    `,
    mobileTextWrapper: css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    `,
    textHeading: css`
      color: #011228;
      font-family: 'FS Dillon';
      font-size: 1.125rem;
      font-style: italic;
      font-weight: 700;
      line-height: 1.375rem;
      letter-spacing: 0.049px;
    `,
    textDescription: css`
      color: #424a5c;
      font-family: 'FS Dillon';
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.25rem;
      letter-spacing: 0.32px;
      text-align: start;
    `,
  };
};
